import { createFileRoute } from '@tanstack/react-router';

import { AwardCreate } from '@/module/Author/Award/AwardCreate';

export const Route = createFileRoute('/_auth/author/_author/award/_award/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <AwardCreate />;
}
